import { Box, Button, Checkbox, Divider, IconButton, styled, Tooltip, Typography } from "@mui/material";
import { BorderedOutlineColumnDirectionFlex, ColumnDirectionAlignStartFlexFill, ColumnDirectionJustifyCenterAlignCenterFlexFill, ColumnJustifyStartFlex, FlexFill, HeightOccupy, RowJustifyCenterFlex, RowJustifyEndFlex, RowJustifySpaceBetweenFlex, RowJustifyStartFlex, StyledSelectField, StyledTextField, VerticalScroll } from "../commons/Containers";
import Search from "../commons/Search";
import { useContext, useEffect, useState } from "react";
import Sort from "../commons/Sort";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ComponentFactory } from "./ComponentFactory";
import _ from "lodash";
import { indigo } from "@mui/material/colors";
import { ComponentPreviewFactory } from "./ComponentPreviewFactory";
import Filter from "../commons/filter/Filter";
import { deleteTemplate, saveTemplate, templateFilter, updateTemplate } from "../../api/Api";
import { BackDropContext, SnackBarContext, WABAContext } from "../main/MainLayout";
import { uploadCreatives, uploadCreativesToMeta } from "./CreativesHandler";

const TemplateGrid = styled(Box)(({ theme }) => ({

    display: 'grid',
    gridTemplateColumns: '1fr 2fr 1fr',
    gridTemplateRows: '1fr',
    alignItems: 'start',
    justifyContent: 'start',
    height: '100%',
    minHeight: 0,

}));

const TemplateNameAndDescriptionGrid = styled(Box)(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr 4fr',
    alignItems: 'center',
    justifyContent: 'start',
    padding: theme.spacing(1),
    gap: theme.spacing(2),
}));

const WhatsappPreviewContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    padding: theme.spacing(1),
}));

const WhatsappConversationContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'black',
    backgroundImage: 'url(https://static.whatsapp.net/rsrc.php/v4/y1/r/a3pd-CgpXeU.png)',
    backgroundPosition: 'center',
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
}));

const WhatsappInboundMessageGrid = styled(Box)(({ theme }) => ({
    display: 'grid',
    width: '100%',
    gridTemplateColumns: '2fr 1fr',
}));

const WhatsappTemplateMessageContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    backgroundColor: '#202C33',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1),
}));

const SORT_FIELDS = [{ name: 'Name', value: 'name' }, { name: 'Description', value: 'description' }];

const languages = [{ name: 'English', value: 'en' }];
const categories = [{ name: 'Marketing', value: 'marketing' }, { name: 'Utility', value: 'utility' }, { name: 'Authentication', value: 'authentication' }];
const categoryComponents = [
    {
        id: 'marketing',
        components: [
            {
                type: 'header',
                required: false,
            },
            {
                type: 'body',
                required: true,
            },
            {
                type: 'footer',
                required: false,
            },
            {
                type: 'buttons',
                required: false,
            }
        ]
    },
    {
        id: 'utility',
        components: [
            {
                type: 'header',
                required: false,
            },
            {
                type: 'body',
                required: true,
            },
            {
                type: 'footer',
                required: false,
            },
            {
                type: 'buttons',
                required: false,
            }
        ]
    },
    {
        id: 'authentication',
        components: [
            {
                type: 'body',
                required: false,
            },
            {
                type: 'buttons',
                required: false,
            }
        ]
    }
];


export const TemplateFilterModel = [
    { _name: 'Description', key: 'description', type: 'text' },
    { _name: 'Active', key: 'active', type: 'checkbox' },
    { _name: 'Categories', key: 'categories', type: 'choice', choices: [{ name: 'Marketing', value: 'marketing' }, { name: 'Utility', value: 'utility' }, { name: 'Authentication', value: 'authentication' }] }
];

export const TemplateList = ({ template, templateHandler, createHandler }) => {

    const [sortField, setSortField] = useState();
    const [sortDirection, setSortDirection] = useState();
    const [templates, setTemplates] = useState([]);
    const [filter, setFilter] = useState({});

    useEffect(() => {
        templateFilter(filter).then(list => setTemplates(list.data));
    }, [filter]);

    const Name = ({ template, setTemplate }) => {
        return <ColumnJustifyStartFlex>
            <Button variant="text-button" onClick={() => setTemplate(template)}>
                <Typography variant="body1">
                    {template.name}
                </Typography>
            </Button>
            <Typography variant="caption">
                {template.description}
            </Typography>
        </ColumnJustifyStartFlex>
    }

    const NameAndCheckbox = ({ template, checked, setChecked, setTemplate }) => {
        return <RowJustifyCenterFlex>
            <Checkbox checked={checked} onChange={(e) => setChecked(e.target.checked)} />
            <Name template={template} setTemplate={setTemplate} />
        </RowJustifyCenterFlex>
    }

    const NameAndActions = ({ template, checked, setChecked, deleteHandler, setTemplate }) => {
        return <RowJustifySpaceBetweenFlex>
            <NameAndCheckbox template={template} checked={checked} setChecked={setChecked} setTemplate={setTemplate} />
            <IconButton size="small" onClick={deleteHandler} >
                <DeleteIcon fontSize="small" />
            </IconButton>
        </RowJustifySpaceBetweenFlex>
    };

    const AuditInfo = ({ template }) => {
        return <RowJustifyStartFlex gap={1}>
            <Typography variant="subtitle2">
                Created: {new Date(template.created).toDateString()}
            </Typography>
            <Typography variant="subtitle2">
                Updated: {new Date(template.updated).toDateString()}
            </Typography>
        </RowJustifyStartFlex>
    };

    const Status = [
        { value: 'APPROVED', color: 'green' },
        { value: 'REJECTED', color: 'RED' },
        { value: 'PENDING', color: 'yellow' },
        { value: 'IN_REVIEW', color: 'orange' }
    ];

    const TemplateStatus = ({ template }) => {
        return <RowJustifyStartFlex gap={1}>
            <Typography variant="body2">
                Status
            </Typography>
            {template.status && <Typography sx={{ backgroundColor: Status.find(e => e.value === template.status)?.color || 'transparent', borderRadius: '8px', padding: '4px', fontSize: '0.8rem', fontWeight: 'bold' }}>
                {`${_.capitalize(template.status)}`}
            </Typography>}
        </RowJustifyStartFlex>
    }

    const TemplateCard = ({ template, checked, setChecked, deleteHandler, setTemplate }) => {
        return <BorderedOutlineColumnDirectionFlex padding={1} gap={1} sx={{ backgroundColor: indigo['50'] }}>
            <NameAndActions template={template} checked={checked} setChecked={setChecked} deleteHandler={deleteHandler} setTemplate={setTemplate} />
            <TemplateStatus template={template} />
            <Divider flexItem />
            <AuditInfo template={template} />
        </BorderedOutlineColumnDirectionFlex>;
    };

    return (<FlexFill borderRight={"1px solid black"} flexDirection={'column'}>
        <RowJustifyStartFlex gap={1} padding={1}>
            <Search placeholder={"search by template name"} search={filter.name ? filter.name : ''} handleSearch={(value) => setFilter(prev => ({ ...prev, name: value }))} maxWidth={24} />
            <Sort options={SORT_FIELDS} defaultOption={'name'} sortFieldHandler={setSortField} directionHandler={setSortDirection} />
        </RowJustifyStartFlex>
        <Divider flexItem />
        <Filter filter={filter} filterHandler={setFilter} model={TemplateFilterModel} />
        <RowJustifySpaceBetweenFlex>
            <RowJustifyStartFlex padding={1} gap={1}>
                <Button variant="outline-rounded-black">
                    Select All
                </Button>
                <Button variant="outline-rounded-black">
                    Deselect All
                </Button>
            </RowJustifyStartFlex>
            <RowJustifyStartFlex padding={1} gap={1}>
                <Tooltip title="Create template">
                    <IconButton size="small" onClick={() => createHandler()}>
                        <AddCircleOutlineIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
                <IconButton size="small">
                    <DeleteIcon fontSize="small" />
                </IconButton>
            </RowJustifyStartFlex>
        </RowJustifySpaceBetweenFlex>
        <Divider flexItem />
        {
            _.isEmpty(templates) ?
                <ColumnDirectionJustifyCenterAlignCenterFlexFill><Typography>There are no templates here, please create one to see details</Typography></ColumnDirectionJustifyCenterAlignCenterFlexFill>
                :
                <ColumnDirectionAlignStartFlexFill padding={1} gap={1} overflow={'auto'}>
                    {templates.map(template => <TemplateCard template={template} setTemplate={templateHandler} deleteHandler={() => template.id && deleteTemplate(template.id)} />)}
                </ColumnDirectionAlignStartFlexFill>
        }
    </FlexFill>);
}

export const TemplateComponent = ({ componentType, optional, properties, template, componentHandler, editing }) => {
    const componentTypes = [{ name: 'Header', value: 'header' }, { name: 'Body', value: 'body' }, { name: 'Footer', value: 'footer' }, { name: 'Buttons', value: 'buttons' }];
    const [expanded, setExpanded] = useState(false);
    const Component = ComponentFactory[componentType];

    return (
        <ColumnJustifyStartFlex>
            <RowJustifyStartFlex>
                <Button variant="text-button" startIcon={expanded ? <ExpandMoreIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />} onClick={() => setExpanded(!expanded)} >
                    <Typography variant="section-header">
                        {componentTypes.find(e => e.value === componentType).name}
                    </Typography>
                    {optional === true && <Typography variant="subtitle2">
                        (Optional)
                    </Typography>}
                </Button>
            </RowJustifyStartFlex>
            {
                expanded ? <Component component={properties} componentHandler={componentHandler} editing={editing} /> : null
            }
        </ColumnJustifyStartFlex >
    );
}

export const TemplateDetail = ({ template, setTemplate, editing, setEditing }) => {

    const { setBackDropMessage, setOpenBackdrop, closeBackdrop } = useContext(BackDropContext);
    const { waba, getAllPhones } = useContext(WABAContext);
    const { setOpenSnackBar, logToSnackBar } = useContext(SnackBarContext);

    const getComponent = (template, type) => {
        const component = template.components.find(e => e.type && e.type === type);
        return _.isUndefined(component) ? { type: type } : component;
    }

    const setComponent = (templateData, templateHandler, type, value) => {
        const components = [...templateData.components.filter(t => !_.isUndefined(t.type) && t.type !== type), value];
        const newTemplate = { ...templateData, components: components };
        console.log(newTemplate);
        templateHandler && templateHandler(newTemplate);
    }

    return _.isEmpty(template) ? <ColumnDirectionJustifyCenterAlignCenterFlexFill>Select a template to see details</ColumnDirectionJustifyCenterAlignCenterFlexFill> : <FlexFill borderRight={"1px solid black"} flexDirection={'column'} padding={1}>
        <RowJustifyEndFlex gap={1} padding={1}>
            {editing ? <>
                <Button variant="outline-rounded-black" onClick={() => {
                    const templateCopy = { ...template };
                    uploadCreativesToMeta({ template: templateCopy, phone: getAllPhones().find(e => e)?.displayPhoneNumber, setOpenBackdrop: setOpenBackdrop, setBackDropMessage: setBackDropMessage, logToSnackBar: logToSnackBar }).then(res => {
                        setBackDropMessage('Creating template...');
                        setOpenBackdrop(true);
                        templateCopy['waba_id'] = waba.find(e => e)?.id;
                        (!templateCopy.id ? saveTemplate({ template: templateCopy }) : updateTemplate({ template: templateCopy })).then(savedTemplate => {
                            templateCopy['id'] = savedTemplate.id;
                            templateCopy['status'] = savedTemplate.status;
                            setOpenBackdrop(false);
                            logToSnackBar({ message: `Created template with id:${templateCopy.id}`, level: 'success' });
                            uploadCreatives({ template: templateCopy, phone: getAllPhones().find(e => e)?.displayPhoneNumber, setOpenBackdrop: setOpenBackdrop, setBackDropMessage: setBackDropMessage, logToSnackBar: logToSnackBar }).then(creative => {
                                updateTemplate({ template: templateCopy, updateMeta: false }).then(creativeUpdated => setTemplate(creativeUpdated));
                            });
                        }).catch(error => {
                            setOpenBackdrop(false);
                            logToSnackBar({ messsage: `Error creating template, error:${error?.message}`, level: 'error' });
                            setTemplate(templateCopy);
                        });
                    });
                }}>
                    Save
                </Button>
                <Button variant="outline-rounded-black" onClick={() => setEditing(false)}>
                    Cancel
                </Button>
            </> : <Button variant="outline-rounded-black" onClick={() => setEditing(true)}>
                Edit
            </Button>}
        </RowJustifyEndFlex>
        <TemplateNameAndDescriptionGrid>
            <Typography variant="attribute">
                Name
            </Typography>
            <StyledTextField editing={editing} value={template.name ? template.name : ''} valueHandler={(value) => setTemplate({ ...template, name: value })} />
            <Typography variant="attribute">
                Description
            </Typography>
            <StyledTextField editing={editing} multiline width="35ch" value={template.description ? template?.description : ''} valueHandler={value => setTemplate({ ...template, description: value })} maxRows={3} />
            <Typography variant="attribute">
                Language
            </Typography>
            <StyledSelectField editing={editing} options={languages} value={template.language ? template.language : ''} valueHandler={value => setTemplate({ ...template, language: value })} />
            <Typography variant="attribute">
                Category
            </Typography>
            <StyledSelectField editing={editing} options={categories} value={template.category ? template.category : ''} valueHandler={value => setTemplate({ ...template, category: value })} />
            <Typography variant="attribute">
                Opt-out String
            </Typography>
            <StyledTextField editing={editing} width="12ch" value={template.opt_out_string ? template.opt_out_string : ''} valueHandler={(value) => setTemplate({ ...template, opt_out_string: value })} />
        </TemplateNameAndDescriptionGrid>
        <Divider flexItem />
        <HeightOccupy >
            <VerticalScroll id='vscroll'>
                {
                    categoryComponents.find(e => e.id === template.category)?.components.map(type => <TemplateComponent key={type.type} componentType={type.type} editing={editing} optional={!type.required} template={template} properties={getComponent(template, type.type)} componentHandler={(value) => setComponent(template, setTemplate, type.type
                        , value)} />)
                }
            </VerticalScroll>
        </HeightOccupy>
    </FlexFill>;
}



export const TemplatePreview = ({ template }) => {


    function sortByType(components) {
        const order = ["header", "body", "footer", "buttons"];

        const priority = Object.fromEntries(
            order.map((type, index) => [type, index])
        );

        return [...components].sort(
            (a, b) =>
                (priority[a.type] ?? Number.MAX_SAFE_INTEGER) -
                (priority[b.type] ?? Number.MAX_SAFE_INTEGER)
        );
    };


    return (

        _.isEmpty(template) ? <ColumnDirectionJustifyCenterAlignCenterFlexFill><Typography>Select a template to see preview</Typography> </ColumnDirectionJustifyCenterAlignCenterFlexFill> : <WhatsappPreviewContainer>
            <Typography variant="h6">
                Preview
            </Typography>
            <WhatsappConversationContainer>
                <WhatsappInboundMessageGrid>
                    <WhatsappTemplateMessageContainer gap={1}>
                        {sortByType(template.components).map(component => {
                            const PreviewComponent = ComponentPreviewFactory[component.type];
                            return PreviewComponent && <PreviewComponent key={component.type} component={component} />;
                        })}
                    </WhatsappTemplateMessageContainer>
                </WhatsappInboundMessageGrid>
            </WhatsappConversationContainer>
        </WhatsappPreviewContainer>
    );
}

export default function TemplatesLayout() {
    const [template, setTemplate] = useState();
    const [editing, setEditing] = useState();

    useEffect(() => {

    }, []);

    const createTemplate = () => {
        setTemplate({ components: [] });
        setEditing(true);
    }

    return (
        <HeightOccupy>
            <TemplateGrid>
                <TemplateList template={template} templateHandler={setTemplate} createHandler={createTemplate} />
                <TemplateDetail template={template} setTemplate={setTemplate} editing={editing} setEditing={setEditing} />
                <TemplatePreview template={template} />
            </TemplateGrid>
        </HeightOccupy>
    );
}